import * as React from "react";
import * as uuid from "uuid";

import { DataSourceMyBagProvider } from "../data-source--mybag-provider";
import { DataMutationMyBagItemChangeQuantityProvider } from "../data-mutation--mybag-item-change-quantity";
import { DataMutationMyBagItemRemoveProvider } from "../data-mutation--mybag-item-remove";
import { DataSourceMyBagTotalsProvider } from "../data-source--mybag-totals-provider";
import { DataMutationMyBagPromoCodeApplyProvider } from "../data-mutation--mybag-promo-code-apply";
import { DataMutationMyBagPromoCodeRemoveProvider } from "../data-mutation--mybag-promo-code-remove";
import { DataMutationShippingSetGuestEmailProvider } from "../data-mutation--shipping-set-guest-email";
import { DataMutationShippingSetShippingAddressesOnCartProvider } from "../data-mutation--shipping-set-shipping-addresses-on-cart";
import { DataMutationShippingSetShippingMethodsOnCartProvider } from "../data-mutation--shipping-set-shipping-methods-on-cart";
import { DataMutationShippingSetBillingAddressesOnCartProvider } from "../data-mutation--shipping-set-billing-addresses-on-cart";
import { DataMutableSourceSuccessClientStorageDataProvider } from "../data-mutable-source-success-client-storage-data";
import { ApplyAGiftcardFormProvider } from "../apply-a-giftcard-form";
import { DataMutationMyBagGiftcardApplyProvider } from "../data-mutation--mybag-giftcard-apply";
import { DataMutationMyBagGiftcardRemoveProvider } from "../data-mutation--mybag-giftcard-remove";

import { useReactMyBagInitialState } from "../react-my-bag-initial-state-provider";

import { MyBagDataSourceIntersectionProvider } from "./my-bag-data-source-intersection-provider";
import { MyBagInitializationProvider } from "./my-bag-initialization-provider";
import { MyBagPresentationModelProvider } from "./my-bag-presentation-model-provider";
import { MyBagLoadingStateProvider } from "./my-bag-loading-state-provider";
import { MyBagItemsRunningStateProvider } from "./my-bag-items-running-state";
import { MyBagUserExperienceProvider } from "./my-bag-user-experience-provider";
import { MyBagOutOfStockUserExperienceProvider } from "./my-bag-out-of-stock-user-experience-provider";
import { MyBagOutOfStockPresentationModelProvider } from "./my-bag-out-of-stock-presentation-model";
import { MyBagTotalsDataSourceIntersectionProvider } from "./my-bag-totals-data-source-intersection-provider";
import { MyBagAutoRoutes } from "./my-bag-auto-routes";

export const MyBagProvider: React.FunctionComponent = (props) => {
  const thisProviderId = React.useMemo(() => {
    return uuid.v4();
  }, []);
  return (
    <DataSourceMyBagTotalsProvider>
      <DataMutableSourceSuccessClientStorageDataProvider>
        <MyBagTotalsDataSourceIntersectionProvider>
          <DataSourceMyBagProvider>
            <DataMutationMyBagItemRemoveProvider
              useInitialState={useReactMyBagInitialState}
            >
              <DataMutationMyBagItemChangeQuantityProvider
                useInitialState={useReactMyBagInitialState}
              >
                <DataMutationMyBagPromoCodeApplyProvider
                  useInitialState={useReactMyBagInitialState}
                >
                  <DataMutationMyBagPromoCodeRemoveProvider
                    useInitialState={useReactMyBagInitialState}
                  >
                    <DataMutationShippingSetGuestEmailProvider
                      useInitialState={useReactMyBagInitialState}
                    >
                      <DataMutationShippingSetShippingAddressesOnCartProvider
                        useInitialState={useReactMyBagInitialState}
                      >
                        <DataMutationShippingSetShippingMethodsOnCartProvider
                          useInitialState={useReactMyBagInitialState}
                        >
                          <DataMutationShippingSetBillingAddressesOnCartProvider
                            useInitialState={useReactMyBagInitialState}
                          >
                            <MyBagDataSourceIntersectionProvider>
                              <DataMutationMyBagGiftcardApplyProvider
                                useInitialState={useReactMyBagInitialState}
                              >
                                <DataMutationMyBagGiftcardRemoveProvider
                                  useInitialState={useReactMyBagInitialState}
                                >
                                  <MyBagInitializationProvider
                                    providerId={thisProviderId}
                                  >
                                    <MyBagItemsRunningStateProvider>
                                      <MyBagLoadingStateProvider>
                                        <MyBagPresentationModelProvider>
                                          <MyBagOutOfStockPresentationModelProvider>
                                            <MyBagAutoRoutes>
                                              <ApplyAGiftcardFormProvider>
                                                <MyBagOutOfStockUserExperienceProvider>
                                                  <MyBagUserExperienceProvider>
                                                    {props.children || []}
                                                  </MyBagUserExperienceProvider>
                                                </MyBagOutOfStockUserExperienceProvider>
                                              </ApplyAGiftcardFormProvider>
                                            </MyBagAutoRoutes>
                                          </MyBagOutOfStockPresentationModelProvider>
                                        </MyBagPresentationModelProvider>
                                      </MyBagLoadingStateProvider>
                                    </MyBagItemsRunningStateProvider>
                                  </MyBagInitializationProvider>
                                </DataMutationMyBagGiftcardRemoveProvider>
                              </DataMutationMyBagGiftcardApplyProvider>
                            </MyBagDataSourceIntersectionProvider>
                          </DataMutationShippingSetBillingAddressesOnCartProvider>
                        </DataMutationShippingSetShippingMethodsOnCartProvider>
                      </DataMutationShippingSetShippingAddressesOnCartProvider>
                    </DataMutationShippingSetGuestEmailProvider>
                  </DataMutationMyBagPromoCodeRemoveProvider>
                </DataMutationMyBagPromoCodeApplyProvider>
              </DataMutationMyBagItemChangeQuantityProvider>
            </DataMutationMyBagItemRemoveProvider>
          </DataSourceMyBagProvider>
        </MyBagTotalsDataSourceIntersectionProvider>
      </DataMutableSourceSuccessClientStorageDataProvider>
    </DataSourceMyBagTotalsProvider>
  );
};
